import React from "react";
import "./Contact_us.css";
import Stay_Connected from "../home/stay_Connected/Stay_Connected";
import Contact_us_Form from "./contact_us_Form/Contact_us_Form";
import GreenStrip from "../common-components/common_green_strip/GreenStrip";

function Contact_us() {
  return (
    <>
      {" "}
      <GreenStrip heading="Contact Us" />
      <section className="Contact_us ">
        <div>
          <Contact_us_Form />
        </div>
        {/* <Stay_Connected /> */}
      </section>
    </>
  );
}

export default Contact_us;
